import TextInner from './TextInner';

export default TextInner;
